import { render } from "./index.vue?vue&type=template&id=819d442e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=819d442e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819d442e"],['__file',"src/views/widget/landing/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "819d442e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('819d442e', __exports__)) {
    console.log('reload')
    api.reload('819d442e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=819d442e&scoped=true", () => {
    console.log('re-render')
    api.rerender('819d442e', render)
  })

}


export default __exports__